/**
 * sophior-klaviyo-form.js
 * Nieuwsbriefinschrijving in de footer rechtstreeks naar een Klaviyo-lijst
 * via de publieke client-API. Werkt met alleen een lijst-ID en de publieke
 * API-key (theme settings); geen Klaviyo embed-formulier of onsite-JS nodig.
 * Bevat daarnaast de back-in-stock-inschrijving voor uitverkochte PDP's
 * ([data-klaviyo-bis-form]) op variantniveau, zodat de Klaviyo
 * "Back in Stock"-flow automatisch triggert zodra er weer voorraad is.
 */
(function () {
  document.querySelectorAll('[data-klaviyo-form]').forEach(function (form) {
    var msg = form.parentElement.querySelector('[data-klaviyo-msg]');

    function showMessage(text) {
      if (!msg) return;
      msg.hidden = false;
      msg.textContent = text;
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var emailInput = form.querySelector('input[type="email"]');
      var btn = form.querySelector('button[type="submit"]');
      if (!emailInput || !emailInput.value) return;
      if (btn) btn.disabled = true;

      var payload = {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'Footer nieuwsbrief',
            profile: {
              data: {
                type: 'profile',
                attributes: { email: emailInput.value }
              }
            }
          },
          relationships: {
            list: {
              data: { type: 'list', id: form.dataset.klaviyoList }
            }
          }
        }
      };

      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(form.dataset.klaviyoCompany), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
        body: JSON.stringify(payload)
      })
        .then(function (r) {
          if (!r.ok) throw new Error('Klaviyo subscribe failed: ' + r.status);
          form.hidden = true;
          showMessage(msg ? msg.dataset.success : '');
        })
        .catch(function () {
          if (btn) btn.disabled = false;
          showMessage(msg ? msg.dataset.error : '');
        });
    });
  });

  document.querySelectorAll('[data-klaviyo-bis-form]').forEach(function (form) {
    var msg = form.parentElement.querySelector('[data-klaviyo-msg]');

    function showMessage(text) {
      if (!msg) return;
      msg.hidden = false;
      msg.textContent = text;
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var emailInput = form.querySelector('input[type="email"]');
      var btn = form.querySelector('button[type="submit"]');
      if (!emailInput || !emailInput.value) return;
      if (btn) btn.disabled = true;

      var payload = {
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            channels: ['EMAIL'],
            profile: {
              data: {
                type: 'profile',
                attributes: { email: emailInput.value }
              }
            }
          },
          relationships: {
            variant: {
              data: {
                type: 'catalog-variant',
                id: '$shopify:::$default:::' + form.dataset.variantId
              }
            }
          }
        }
      };

      fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + encodeURIComponent(form.dataset.klaviyoCompany), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
        body: JSON.stringify(payload)
      })
        .then(function (r) {
          if (!r.ok) throw new Error('Klaviyo BIS subscribe failed: ' + r.status);
          form.hidden = true;
          showMessage(msg ? msg.dataset.success : '');
        })
        .catch(function () {
          if (btn) btn.disabled = false;
          showMessage(msg ? msg.dataset.error : '');
        });
    });
  });
})();
